import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API, ApiAdmin, GetDate_ } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
export default function Msrofat() {
  const navigate = useNavigate();

  //---------ShowModal----------------------------

  const [TypeModal, SetTypeModal] = useState("");
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);

  const [Total, SetTotal] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [Inputs, setInputs] = useState([
    {
      from: GetDate_.FirstMonth,
      to: GetDate_.Today,
      date_amlia: GetDate_.Today,
      type: "all",
    },
  ]);
  //===========Check Login ================
  LoginCheck();
  var admininfo = [];
  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Data, SetData] = useState([]);
  const [MasrofatTYPE, SetMasrofatTYPE] = useState([]);

  useEffect(() => {
    setInputs((values) => ({ ...values, ["from"]: GetDate_.FirstMonth }));
    setInputs((values) => ({ ...values, ["to"]: GetDate_.Today }));
    setInputs((values) => ({ ...values, ["date_amlia"]: GetDate_.Today }));
  }, []);

  useEffect(() => {
    GetMasrofatSearch(GetDate_.FirstMonth, GetDate_.Today);
  }, []);
  //-------------------------------------------------------------
  async function GetMasrofatSearch(from, to, type) {
    try {

      const post = {
        from: from,
        to: to,
        type: "",
        Action: "Search",
      };

      if (post.from == null) {
        return alert("الرجاء اختيار تاريخ بداية البحث");
      }
      if (post.to == null) {
        return alert("الرجاء اختيار تاريخ نهاية البحث");
      }

      const response = await fetch(ApiAdmin + "/msrofat.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data_ = await response.json();
      SetData(data_.data);
      SetTotal(data_.total);
    } catch (error) {
      return error;
    }
  }

  //======================================================
  useEffect(() => {
    GetMasrofatTYPE();
  }, []);
  async function GetMasrofatTYPE() {
    try {
      const post = {
        Action: "MasrofatTYPE",
      };

      const response = await fetch(ApiAdmin + "/msrofat.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      SetMasrofatTYPE(data.data);
    } catch (error) {
      return error;
    }
  }

  //-------------------------------------------------------------
  async function DeleteMasrofat(id) {
    try {
      const post = {
        id: id,
        Action: "Delete",
      };

      const response = await fetch(ApiAdmin + "/msrofat.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data_ = await response.json();
      console.log(data_);
      GetMasrofatSearch(Inputs.from, Inputs.to, "");
    } catch (error) {
      return error;
    }
  }

  //----------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //=================================
  //-------------------------------------------------------------
  async function ChangeModel(x) {
    SetTypeModal(x);
    handleShowModal();
  }



  //----------------------------------------
  const handleSubmiAdd = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());

    if (window.confirm(`هل تريد اضافة مصروفات `)) {
      try {
        const response = await fetch(ApiAdmin + "/msrofat.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          alert(data.errors);
        }
        if (data.msg != "") {
          console.log(data.msg);
          // handleCloseModal();
          GetMasrofatTYPE();
          GetMasrofatSearch(Inputs.from, Inputs.to, "");

        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };


  //----------------------------------------
  const handleSubmiSearch = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());

    try {
      const response = await fetch(ApiAdmin + "/msrofat.php", {
        method: "POST",
        body: JSON.stringify(data_),
      });

      const data = await response.json();
      console.log(data);
      if (data.errors != "") {
        alert(data.errors);

      }
      if (data.msg != "") {
        SetData(data.data);
        SetTotal(data.total);
        handleCloseModal();
      }

      if (response.ok) {
      } else if (response.status === 400) {
        return alert("errorr 400");
      } else {
        return alert("can not save ");
      }
    } catch (error) {
      console.log(error);
    }

  };

  return (
    <>
      <Header_ />
      <div
        dir="rtl"
        className="row text-center m-auto"
        style={{ maxWidth: "1000px" }}
      >
        <h3 className="text-orange fw-bold py-1"> المصروفات </h3>
        {/* -------------- */}

        {/* ======================= */}
        <div className="col-6 text-end">
          <button className="btn btn-green mx-1 px-2 fw-bold" onClick={() => ChangeModel("AddFORM")}>اضافة بيان</button>
          <button className="btn btn-syan px-2 fw-bold" onClick={() => ChangeModel("SearchForm")}> بحث</button>
        </div>

        <div className="col-6 text-start">
          <h5 className="text-syan">الاجمالى  : {Total}</h5>
        </div>
        <div className="col-12 mt-1 bg-light0 text-center">
          <div className="table-responsive">
            <table
              dir="rtl"
              className="table table-striped0 table-hover m-auto"
              style={{ minWidth: "820px" }}
            >
              <thead>
                <tr>
                  <th className="text-end px-2" width="120px">النوع</th>
                  <th className="text-end px-2" width="200px">البيان</th>
                  <th width="80px">المبلغ</th>
                  <th width="80px">التاريخ</th>
                  <th width="30px"> حذف</th>
                </tr>
              </thead>
              <tbody>
                {Data.length < 1 && (
                  <tr>
                    <td
                      className="text-center fs-6 fw-bold text-danger"
                      colSpan="6"
                    >
                      لا توجد بيانات
                    </td>
                  </tr>
                )}
                {Data.length > 0 && (
                  Data.map((x, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-end">{x.type}</td>
                        <td className="text-end">{x.title}</td>
                        <td className="text-center">{x.mony}</td>
                        <td className="text-center">{x.date_amlia}</td>
                        <td className="text-center">
                          <span
                            className="text-danger fw-bold p-3"
                            onClick={() => DeleteMasrofat(x.id)}
                          >
                            {"X "}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* } */}

        {/* -------------- */}

        {/* ============================= */}

      </div>
      <br />
      <br />
      <br />
      <ModalSHOW />
    </>
  );

  function ModalSHOW() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <h6 className="text-danger p-0 m-0" onClick={handleCloseModal}>
              X
            </h6>
            {TypeModal == "AddFORM" && <AddFORM />}
            {TypeModal == "SearchForm" && <SearchForm />}
          </Modal.Body>
        </Modal>
      </>
    );
  }

  //========================================
  function AddFORM() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmiAdd}>
          <input type="hidden" name="Action" value="Add" />
          <div className="row mt-1 px-0">
            <div className="col-12 text-center">
              {/* <i className="fa-brands fa-cc-visa  m-0 p-0 text-warning fs-1 mb-2"></i> */}
              <h4 className="text-syan"> اضافة المصروفات </h4>
            </div>
            <div className="col-6">
              <label htmlFor=""> التاريخ</label>
              <input
                type="date"
                name="date_amlia"
                className="form-control"
                autoComplete="off"
                // onClick={handleDubelClick}
                onChange={handleChange}
                value={Inputs.date_amlia}
              />
            </div>
            <div className="col-12">
              <label htmlFor=""> نوع المصروفات</label>
              <input
                name="type"
                id="type"
                // value={inputValue}
                // onChange={(e) => setInputValue(e.target.value)}
                list="combo_type"
                className="form-control text-end mt-1"
                autoComplete="off"
              />
              <datalist name="combo_type" id="combo_type">
                <option value="" />
                {MasrofatTYPE.map((x, index) => {
                  return (
                    <option key={index} value={x.type} />
                  );
                })}

              </datalist>

            </div>
            <div className="col-12">
              <label htmlFor=""> البيان</label>
              <input
                type="text"
                name="title"
                className="form-control text-emd mt-1"
                autoComplete="off"
              />
            </div>
            <div className="col-6">
              <label htmlFor=""> المبلغ</label>
              <input
                type="number"
                name="mony"
                className="form-control text-center mt-1"
                autoComplete="off"
              />
            </div>
            <div className="col-12 text-center0 mx-2 mt-4 ">
              <button className="btn btn-syan fw-bold fs-6 px-4">حفظ</button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }

  //========================================
  function SearchForm() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmiSearch}>
          <input type="hidden" name="Action" value="Search" />
          <div dir="rtl" className="row text-end">
            <h4 className="text-center text-syan">بحث</h4>
            <div className="col-lg-6 col-6 text-end">

              <label className="col-form-label" autoComplete="off">
                من تاريخ
              </label>
              <input
                type="date"
                name="from"
                className="form-control"
                autoComplete="off"
                // onClick={handleDubelClick}
                onChange={handleChange}
                value={Inputs.from}
              />
            </div>
            <div className="col-lg-6 col-6  text-end">
              <label className="col-form-label" autoComplete="off">
                الى تاريخ
              </label>
              <input
                type="date"
                name="to"
                className="form-control"
                autoComplete="off"
                // onClick={handleDubelClick}
                onChange={handleChange}
                value={Inputs.to}
              />
            </div>
            <div className="col-lg-12 col-12  text-end">
              <label className="col-form-label" autoComplete="off">
                البيان
              </label>
              <select
                name="type"
                className="form-control"
              // onChange={handleChange}
              >
                <option value=""></option>
                {MasrofatTYPE.map((x, index) => {
                  return (
                    <option
                      key={index}
                      value={x.type}
                    >
                      {x.type}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-12 pt-1">
              <button className="btn btn-syan mt-4">بحث</button>
            </div>
          </div>
        </form>
      </>
    );
  }

}
